export default __webpack_public_path__ + "static/media/carol.5875b05b.png";